






































































































































import { Vue, Component, Prop } from "@/shared/vuepack";
import { useBankAccountStore } from "@/employee/store/bankAccount";
import { useFeatureFlagStore } from "@/shared/store/featureFlag";
import AccountHolderWidgetBase from "@/employer/components/partner-ee-service/AccountHolderWidgetBase.vue";
import ConsumerLinkedAccountAlert from "@/shared/components/accountAlert/ConsumerLinkedAccountAlert.vue";
import { linkedBankAccountUseStatusIconMap, accountVerificationStatusIconMap } from "@/shared/awesomeIconMapper";
import {
  LinkedBankAccountUseStatus,
  LinkedAccountApi,
  AchVerifier,
  achVerifierDisplayMap,
  bankAccountUseDisplayMap,
  LinkedBankAccountUse,
  AccountVerificationStatus,
  linkedBankAccountUseStatusDisplayMap,
  accountVerificationStatusDisplayMap,
} from "@/shared/types";
import _ from "lodash";
import { isNullEmptyOrUndefined } from "@/shared/stringHelper";
import moment from "moment/moment";

@Component({
  components: {
    ConsumerLinkedAccountAlert,
    AccountHolderWidgetBase
  }
})
export default class ConsumerLinkedBankAccounts extends Vue {
  bankAccountStore = useBankAccountStore();
  featureFlagStore = useFeatureFlagStore();
  bankAccountUseDisplayMap = bankAccountUseDisplayMap;
  linkedBankAccountUseStatusIconMap = linkedBankAccountUseStatusIconMap;
  accountVerificationStatusIconMap = accountVerificationStatusIconMap;
  linkedBankAccountUseStatusDisplayMap = linkedBankAccountUseStatusDisplayMap;
  accountVerificationStatusDisplayMap = accountVerificationStatusDisplayMap;
  LinkedBankAccountUseStatus = LinkedBankAccountUseStatus;
  achVerifierDisplayMap = achVerifierDisplayMap;
  showConfirmModal = false;
  isSubmitting = false;
  bankAccountToDelete: LinkedAccountApi = null;
  showReplaceModal = false;
  bankAccountToReplace: LinkedAccountApi = this.init();

  linkType = [
    { text: "Checking", value: "checking" },
    { text: "Savings", value: "savings" }
  ];
  init (): LinkedAccountApi {
    return {
      bankAccountName: "",
      bankAccountNumber: "",
      bankRoutingNumber: "",
      bankName: "",
      use: null,
      linkedBankAccountId: 0,
      linkedBankAccountType: "checking",
      verificationStatus: AccountVerificationStatus.Verified,
      hasPersonalContributionSchedules: false,
      apiErrorMessage: null,
      apiErrorStatusCode: "ok",
      apiErrorTimestamp: null
    };
  }

  @Prop()
  username: string;

  mounted () {
    this.bankAccountStore.getIsFraudAdmin();
  }
  get title (): string {
    return this.canAdministerLinkedAccounts ? "Manage External Linked Bank Accounts" : "External Linked Bank Accounts";
  }
  get allAccounts (): any[] {
    if (!this.bankAccountStore.linkedAccounts) {
      return [];
    }
    return this.bankAccountStore.linkedAccounts.sort((a, b) => a.linkedBankAccountType.localeCompare(b.linkedBankAccountType))
      .map(item => ({...item, isEdit: false, isMissingUse: item.use.accountUse === LinkedBankAccountUse.Unspecified, name: item.bankAccountName, hasError: item.apiErrorMessage !== null}));
  }
  get hasLinkedAccounts (): boolean {
    return this.bankAccountStore.linkedAccounts && this.bankAccountStore.linkedAccounts.length > 0;
  }
  get canAdministerLinkedAccounts (): boolean {
    return this.featureFlagStore.flags.bend25871FraudAdminCanManageLinkedBankAccounts
      && this.bankAccountStore.achVerifier === AchVerifier.Finicity // this won't work for other ACH verifiers, like UMB
      && this.bankAccountStore.canAdministerLinkedAccounts;
  }
  addLinkedAccount () {
    this.bankAccountToReplace = this.init();
    this.showReplaceModal = true;
  }
  replaceRowHandler (data) {
    this.bankAccountToReplace = _.cloneDeep(data.item);
    this.bankAccountToReplace.bankAccountNumber = "";
    this.showReplaceModal = true;
  }
  onReplaceModalClose () {
    this.bankAccountToReplace = this.init();
    this.showReplaceModal = false;
  }
  onReplace () {
    this.$validator.validateAll().then(isValid => {
      if (!isValid) {
        return;
      }
      this.isSubmitting = true;
      this.showReplaceModal = false;
      if (this.bankAccountToReplace) {
        const options = {linkedAccountToReplace: this.bankAccountToReplace, username: this.username, partnerId: 0 };
        this.bankAccountStore.adminReplaceLinkedAccount(options);
      }
      this.loadLinkedBankAccounts();
      this.isSubmitting = false;
      this.bankAccountToReplace = this.init();
    });
  }
  get submitDisabled () {
    return this.$validator.errors.any() || this.isSubmitting || this.isConsumerLinkedAccountsInErrorState;
  }
  get isConsumerLinkedAccountsInErrorState (): boolean {
    return this.bankAccountStore.isConsumerLinkedAccountsInErrorState;
  }
  deleteRowHandler (data) {
    this.bankAccountToDelete = data.item;
    this.showConfirmModal = true;
  }
  onModalClose () {
    this.bankAccountToDelete = null;
    this.showConfirmModal = false;
  }
  onConfirmDelete () {
    this.isSubmitting = true;
    this.showConfirmModal = false;
    if (this.bankAccountToDelete) {
      const options = {linkedAccountToDelete: this.bankAccountToDelete, username: this.username, partnerId: 0 };
      this.bankAccountStore.adminDeleteLinkedAccount(options);
    }
    this.loadLinkedBankAccounts();
    this.isSubmitting = false;
    this.bankAccountToDelete = null;
  }
  loadLinkedBankAccounts () {
    const args = { username: this.username, partnerId: 0 };
    this.bankAccountStore.loadLinkedBankAccountsForUser(args);
  }
  get isLoading () {
    return !this.bankAccountStore.linkedAccountsLoaded || this.isSubmitting;
  }
  get isFailed () {
    return false;
  }
  loadData () {
    this.loadLinkedBankAccounts();
  }
  listFields = [{
    key: "bankAccountName",
    thClass: "text-left",
    tdClass: "",
    label: "Account Name"
  },
    {
      key: "bankName",
      thClass: "text-left",
      tdClass: "",
      label: "Bank Name"
  },
  {
    key: "bankAccountRouting",
    thClass: "text-left pl-1",
    tdClass: "pl-1",
    label: "Routing"
  },
  {
    key: "bankAccountNumber",
    thClass: "text-left pl-1",
    tdClass: "pl-1",
    label: "Account"
  },
  {
    key: "uses",
    label: "Use",
    thClass: "text-left",
    tdClass: "text-left"
  },
  {
    key: "delete",
    label: "",
    thClass: "",
    tdClass: "text-right"
  }];
  getFormattedDate (date?: string): string {
    if (isNullEmptyOrUndefined(date)) {
      return "";
    }
    const local = moment.utc(date).local();
    if (isNullEmptyOrUndefined(local.zoneAbbr())) {
      return `${local.format("MM/DD/YYYY hh:mma")} ${local.tz(moment.tz.guess()).zoneAbbr()}`;
    }
    return local.format("MM/DD/YYYY hh:mma z");
  }
}
